import React from 'react';
import { shape, string, arrayOf } from 'prop-types';

import ContactCardPanel from '../contact-card-panel';

const CurrentInfo = (props) => {
  const matomoTrackingClass = 'aktuellt';
  return props.Items.map((item, index) => (
    <div className="current-info" key={index}>
      <ContactCardPanel
        subheading={true}
        hasH3={true}
        contactCardHeading={item.Title}
        Modifiers={{ 'child-overflow-visible': true }}
        isLast={index === props.Items.length - 1}
      >
        {item.PublishFrom && (
          <span className="current-info__publishdate">
            {props.Translations.published}
            {item.PublishFrom}
          </span>
        )}

        {item.Text && (
          <div
            className="current-info__publishdate__content"
            dangerouslySetInnerHTML={{ __html: item.Text }}
          />
        )}
        {item.Link && (
          <div className={`${matomoTrackingClass}`}>
            <a href={item.Link.Url}>{item.Link.Text}</a>
          </div>
        )}
      </ContactCardPanel>
    </div>
  ));
};

CurrentInfo.propTypes = {
  /** (BE) */
  Translations: shape({
    showmoretext: string,
    showlesstext: string,
  }),
  /** (BE) */
  Items: arrayOf(
    shape({
      PublishFrom: string,
      Text: string,
      Link: shape({
        Text: string,
        Url: string,
      })
    })
  ),
};

export default CurrentInfo;
